import { useMemo } from 'react';
import { TFunction } from 'i18next';
import { FieldItem } from '@lib/interfaces/form';
import Input from '@lib/components/Input/Input';
import Trans from '@lib/components/Trans/Trans';
import { getFieldValidation } from '@lib/utils/validationUtils';
import FieldArrayItemWrapperComponent from '../FieldArrayItemWrapperComponent';
import styles from '../CustomizeTabsModalForm.module.scss';

interface UseCustomizeTabsFieldsArgs {
  isViewOnly: boolean;
  t: TFunction<'translation', undefined>;
}

export function useCustomizeTabsFields({
  isViewOnly,
  t,
}: UseCustomizeTabsFieldsArgs): FieldItem[] {
  return useMemo(
    () => [
      {
        name: 'tabs',
        isDraggable: true,
        isSubItemDisabledFn: (value) => {
          const isDefault = (value as { isDefault?: boolean })?.isDefault;
          return isViewOnly && !!isDefault; // Disabled if default when isViewOnly
        },
        isSubItemDraggableFn: (value) => {
          const isDefault = (value as { isDefault?: boolean })?.isDefault;
          return !isDefault; // Draggable if NOT default
        },
        isSubItemRemovableFn: (value) => {
          const isDefault = (value as { isDefault?: boolean })?.isDefault;
          return !isDefault; // Removable if NOT default
        },
        subFieldsAddMoreButtonText: <Trans i18nKey="add-tab" />,
        subFieldsEntity: 'tab',
        subFieldsMinLength: 1,
        subFieldsMaxLength: 10,
        subFieldsMaxLengthTooltipProps: {
          body: t('tabs-max-limit-tooltip'),
        },
        subFields: [
          {
            name: 'name',
            element: Input,
            label: t('tab-name'),
            componentProps: {
              placeholder: t('tab-name'),
            },
            validation: getFieldValidation({
              t,
              required: true,
            }),
            formItemClassName: styles.tabNameField,
            hideErrorsSpace: true,
            isUnique: true,
          },
        ],
        fieldComponents: {
          FieldArrayItemWrapperComponent,
        },
      },
    ],
    [isViewOnly, t],
  );
}
